import Actions from "./DoorActionTypes";

export const fetchAllDoors = (params = {}) => {
  return {
    type: Actions.FETCH_ALL_DOOR,
    payload: params,
  };
};
